const getters = {
  getLoading: (state) => state.loading,
  getTheme: (state) => state.theme,
  getCustomer: (state) => state.customer,
  getStepsData: (state) => state.stepsData,
  getStates: (state) => state.states,
  getCart: (state) => state.cart,
  getCartHash: (state) => state.cartHash,
  getPaymentType: (state) => state.payment_type,
  getCurrentStep: (state) => state.currentStep,
  getPaymentCard: (state) => state.paymentCard,
  getPaymentBillet: () => JSON.parse(localStorage.getItem('paymentBillet')),
  getPaymentPix: (state) => state.cart.payment,
  getCartLoading: (state) => state.cartLoading,
  getDisebleOrEnableAddRemove: (state) => state.disebleOrEnableAddRemove,
  getRecaptchaAttempts: (state) => state.cart.recaptcha_attempts,
}

export default getters
